import { PolicyExtractionListResponse, PolicyDetailsDTO } from '../infrastructure/models';
import ApiService from "./ApiService";
import api from "./api";

export const fetchAllPolicies = async (tenantId: string, offset = 0, limit = 10, signal?: AbortSignal): Promise<PolicyExtractionListResponse> => {
    const response = await ApiService.get<PolicyExtractionListResponse>({ url: `tenants/${tenantId}/PolicyExtractions?offset=${offset}&limit=${limit}`, signal });
    return response;
}

export const uploadNewPolicy = async (tenantId: string, location: string, files: File[], signal?: AbortSignal): Promise<void> => {
    const formData = new FormData();
    files.map(file => formData.append('files', file));
    const url = `tenants/${tenantId}/PolicyExtractions?Location=${encodeURIComponent(location)}`;

    await api.post(url, formData, {
        signal,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300_000,
    });
}

export const fetchPolicyDetails = async (tenantId: string, policyExtractionId: string, signal?: AbortSignal): Promise<PolicyDetailsDTO> => {
    const response = await ApiService.get<PolicyDetailsDTO>({ url: `tenants/${tenantId}/PolicyExtractions/${policyExtractionId}`, signal });
    return response;
}

export const deletePolicyExtraction = async (tenantId: string, policyExtractionId: string, signal?: AbortSignal): Promise<void> => {
    await ApiService.delete({ url: `tenants/${tenantId}/PolicyExtractions/${policyExtractionId}`, signal });
}